module.exports = __webpack_public_path__ + "img/Television.53023154.jpg";